import { useState } from 'react'
import useResizeListener from './useResizeListener'

const useNavbarHeight = () => {
  const [navbarHeight, setNavbarHeight] = useState(50)

  useResizeListener(() => {
    const header = document.querySelector('header')
    setNavbarHeight(header?.clientHeight)
  })

  return navbarHeight
}

export default useNavbarHeight
